// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: taken from cellular-spear scss file */
#cellular-chart-card {
  _margin-top: 16px;
  _margin-bottom: 16px;
}
#cellular-chart-card .chart-heading {
  margin: 10px 5px;
  /* font-weight: 600; */
  _align-self: center;
  padding-bottom: 0;
  _margin: 8px 0 0 8px;
  font-weight: 600;
  color: #303c42;
}

.ag-plot-zoom {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99999;
}

.ag-plot-no-zoom {
  padding: 10px;
  position: relative;
}

.ag-plot-legend {
  font-size: 14px;
  margin-top: 10px;
}
.ag-plot-legend .ag-legend-item {
  margin: 2px 5px;
  display: inline-flex;
}
.ag-plot-legend .ag-legend-item .ag-legend-icon {
  align-self: center;
  margin-right: 5px;
  width: 10px;
  height: 10px;
  border-radius: 45px;
}

.device-type-card {
  border-radius: 8px;
  max-height: 96px;
  /* color: white; */
  _margin: 10px 20px;
  background: white;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.device-type-card .select-item-content {
  margin: 25px;
}
.device-type-card .select-item-content .select-item-label {
  margin: 5px 0;
}
.device-type-card .select-item-content .select-item-name {
  margin: 5px 0;
  color: dimgray;
  font-size: 12px;
}
.device-type-card .select-item-content .select-item-description {
  font-family: Roboto;
  font-size: 14px;
  _margin: 5px 0;
}
.device-type-card .img-container {
  width: 96px;
  height: 96px;
  _overflow: hidden;
  _background-color: #fff;
  _border-radius: 50%;
}
.device-type-card .img-container .device-pic {
  margin-right: 25px;
  max-height: 100%;
  _width: 84%;
}
.device-type-card span {
  margin-top: 8px;
  font-size: 16px;
  white-space: pre-wrap;
  /*@media (max-width: 450px) {
    margin-bottom: 0;
    font-size: 13px;
  }*/
}

.sensor-tooltip .sensor-tooltip-header {
  display: flex;
  justify-content: space-between;
}
.sensor-tooltip .sensor-tooltip-header .tooltip-cable-name {
  color: #27ae60;
  font-size: 16px;
}
.sensor-tooltip .sensor-tooltip-header .tooltip-sensor-name {
  font-weight: bold;
}
.sensor-tooltip .sensor-tooltip-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sensor-tooltip .sensor-tooltip-content .tooltip-time {
  align-self: center;
}
.sensor-tooltip .sensor-tooltip-content .tooltip-time-since {
  align-self: center;
}
.sensor-tooltip .sensor-tooltip-body {
  display: flex;
  justify-content: center;
}
.sensor-tooltip .sensor-tooltip-body .tooltip-value {
  font-size: 25px;
  font-weight: bold;
  padding: 10px;
  margin: 10px 0;
  align-self: center;
  display: inline-flex;
  border-radius: 8px;
}
.sensor-tooltip .sensor-tooltip-link {
  display: flex;
  justify-content: center;
}

.silo-table {
  display: flex;
}
.silo-table .table-column-header {
  _min-height: 20px;
  _height: 20px;
  padding: 0px 5px;
  box-sizing: border-box;
  height: 30px;
  min-height: 30px;
  max-height: 30px;
  min-width: 30px;
  font-size: 12px;
  font-weight: 700;
  line-height: 30px;
  color: #27ae60;
  text-align: center;
  border-right: solid 1px rgba(0, 0, 0, 0.05);
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
}
.silo-table .table-row {
  align-items: center;
  display: flex;
  flex-direction: column;
  color: rgba(0, 0, 0, 0.6);
  padding: 0px 10px;
  _min-width: 30px;
  min-height: 30px;
  max-height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.silo-table .table-cell {
  align-items: center;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 30px;
  min-height: 30px;
  height: 30px;
  max-height: 30px;
  font-size: 12px;
  font-weight: 600;
  _color: rgba(0, 0, 0, 0.6);
  text-align: center;
  border: 1px solid transparent;
  border-right: solid 1px rgba(0, 0, 0, 0.05);
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
  line-height: 30px;
}
.silo-table .table-cell.selected {
  _box-shadow: inset 0px 0px 1px 1px #e9e9e9;
  border: 1px solid black;
}

.messurements {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.sensors {
  display: flex;
  justify-content: space-around;
  margin: 10px;
}

.sensor-item {
  background: white;
  border-radius: 2px;
  white-space: pre;
  padding: 3px;
  font-size: 13px;
  position: absolute;
}

.sensor {
  border: 1px solid transparent;
}

.sensor.active {
  border-bottom: 2px solid;
}`, "",{"version":3,"sources":["webpack://./src/app/components/farmer-building/farmer-building.scss"],"names":[],"mappings":"AAGA,8CAAA;AAEA;GAHE,gBAIA;GAHA,mBAIA;AAHF;AAKE;EACC,gBAAA;EACA,sBAAA;GAHD,kBAIC;EACA,iBAAA;GAHD,mBAIE;EACA,gBAAA;EACA,cAAA;AAHJ;;AAMA;EACE,eAAA;EAAiB,WAAA;EAAa,YAAA;EAC9B,MAAA;EAAQ,OAAA;EAAS,cAAA;AACnB;;AACA;EACE,aAAA;EAAe,kBAAA;AAGjB;;AAAA;EACE,eAAA;EACA,gBAAA;AAGF;AAFE;EACE,eAAA;EACA,oBAAA;AAIJ;AAFI;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EAAa,YAAA;EAAc,mBAAA;AAMjC;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;GAGA,iBAFA;EACA,iBAAA;EACA,gHAAA;AAGF;AADE;EACE,YAAA;AAGJ;AAFI;EACE,aAAA;AAIN;AAFI;EACE,aAAA;EACA,cAAA;EACA,eAAA;AAIN;AAFI;EACE,mBAAA;EACA,eAAA;GAIJ,aAHI;AAIN;AAAE;EACE,WAAA;EACA,YAAA;GAEF,gBADE;GAEF,sBADE;GAEF,kBADE;AAEJ;AAAI;EACE,kBAAA;EACA,gBAAA;GAEJ,UADI;AAEN;AAEE;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EAEA;;;IAAA;AAEJ;;AASE;EACE,aAAA;EACA,8BAAA;AANJ;AAOI;EACE,cAAA;EACA,eAAA;AALN;AAOI;EACE,iBAAA;AALN;AAQE;EACE,aAAA;EAAe,sBAAA;EACf,uBAAA;AALJ;AAMI;EACE,kBAAA;AAJN;AAMI;EACE,kBAAA;AAJN;AAOE;EACE,aAAA;EACA,uBAAA;AALJ;AAMI;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;AAJN;AAOE;EACE,aAAA;EACA,uBAAA;AALJ;;AAWA;EACE,aAAA;AARF;AASE;GAPA,gBAQE;GAPF,YAQE;EACA,gBAAA;EAEA,sBAAA;EACA,YAAA;EACA,gBAAA;EAAkB,gBAAA;EAClB,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;EACA,4CAAA;AAPJ;AASE;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;GAPF,eAQE;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAPJ;AASE;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EAAc,gBAAA;EAEd,eAAA;EACA,gBAAA;GARF,yBASE;EACA,kBAAA;EACA,6BAAA;EACA,2CAAA;EACA,4CAAA;EACA,iBAAA;AARJ;AASI;GAPF,yCAQI;EACA,uBAAA;AAPN;;AAYA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AATF;;AAWA;EACE,aAAA;EAAe,6BAAA;EAA+B,YAAA;AANhD;;AAQA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AALF;;AAOA;EACE,6BAAA;AAJF;;AAMA;EACE,wBAAA;AAHF","sourcesContent":["\r\n\r\n\r\n/* NOTE: taken from cellular-spear scss file */\r\n\r\n#cellular-chart-card {\r\n  _margin-top: 16px;\r\n  _margin-bottom: 16px;\r\n\r\n  .chart-heading {\r\n   margin: 10px 5px;\r\n   /* font-weight: 600; */\r\n   _align-self: center; \r\n   padding-bottom: 0;\r\n    _margin: 8px 0 0 8px;\r\n    font-weight: 600;\r\n    color: #303c42;\r\n  }\r\n}\r\n.ag-plot-zoom {\r\n  position: fixed; width: 100%; height: 100%;\r\n  top: 0; left: 0; z-index: 99999;\r\n}\r\n.ag-plot-no-zoom  {\r\n  padding: 10px; position: relative;\r\n}\r\n\r\n.ag-plot-legend {\r\n  font-size: 14px;\r\n  margin-top: 10px;\r\n  .ag-legend-item {\r\n    margin: 2px 5px;\r\n    display: inline-flex;\r\n\r\n    .ag-legend-icon {\r\n      align-self: center;\r\n      margin-right: 5px;\r\n      width: 10px; height: 10px; border-radius: 45px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.device-type-card {\r\n  border-radius: 8px;\r\n  max-height: 96px;\r\n  /* color: white; */\r\n  _margin: 10px 20px;\r\n  background: white;\r\n  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);\r\n\r\n  .select-item-content {\r\n    margin: 25px;\r\n    .select-item-label {\r\n      margin: 5px 0;\r\n    }\r\n    .select-item-name {\r\n      margin: 5px 0;\r\n      color: dimgray;\r\n      font-size: 12px;\r\n    }\r\n    .select-item-description {\r\n      font-family: Roboto;\r\n      font-size: 14px;\r\n      _margin: 5px 0;\r\n    }\r\n  }\r\n\r\n  .img-container {\r\n    width: 96px;\r\n    height: 96px;\r\n    _overflow: hidden;\r\n    _background-color: #fff;\r\n    _border-radius: 50%;\r\n\r\n    .device-pic {\r\n      margin-right: 25px;\r\n      max-height: 100%;\r\n      _width: 84%;\r\n    }\r\n  }\r\n\r\n  span {\r\n    margin-top: 8px;\r\n    font-size: 16px;\r\n    white-space: pre-wrap;\r\n\r\n    /*@media (max-width: 450px) {\r\n      margin-bottom: 0;\r\n      font-size: 13px;\r\n    }*/\r\n  }\r\n}\r\n\r\n\r\n\r\n.sensor-tooltip {\r\n\r\n  .sensor-tooltip-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    .tooltip-cable-name {\r\n      color: #27ae60;\r\n      font-size: 16px;\r\n    }\r\n    .tooltip-sensor-name {\r\n      font-weight: bold;\r\n    }\r\n  }\r\n  .sensor-tooltip-content {\r\n    display: flex; flex-direction: column;\r\n    justify-content: center;\r\n    .tooltip-time {\r\n      align-self: center;\r\n    }\r\n    .tooltip-time-since {\r\n      align-self: center;\r\n    }\r\n  }\r\n  .sensor-tooltip-body {\r\n    display: flex;\r\n    justify-content: center;\r\n    .tooltip-value {\r\n      font-size: 25px;\r\n      font-weight: bold;\r\n      padding: 10px;\r\n      margin: 10px 0;\r\n      align-self: center;\r\n      display: inline-flex;\r\n      border-radius: 8px;\r\n    }\r\n  }\r\n  .sensor-tooltip-link {\r\n    display: flex;\r\n    justify-content: center;\r\n    \r\n  }\r\n}\r\n\r\n\r\n.silo-table {\r\n  display: flex;\r\n  .table-column-header {\r\n    _min-height: 20px;\r\n    _height: 20px;\r\n    padding: 0px 5px;\r\n\r\n    box-sizing: border-box;\r\n    height: 30px;\r\n    min-height: 30px; max-height: 30px;\r\n    min-width: 30px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    line-height: 30px;\r\n    color: #27ae60;\r\n    text-align: center;\r\n    border-right: solid 1px rgba(0,0,0,0.05);\r\n    border-bottom: solid 1px rgba(0,0,0,0.05);\r\n  }\r\n  .table-row {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: rgba(0,0,0,0.6);\r\n    padding: 0px 10px;\r\n    _min-width: 30px;\r\n    min-height: 30px;\r\n    max-height: 30px;\r\n    line-height: 30px;\r\n    font-size: 12px;\r\n  }\r\n  .table-cell {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    box-sizing: border-box;\r\n    min-width: 30px;\r\n    min-height: 30px;\r\n    height: 30px; max-height: 30px;\r\n\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    _color: rgba(0,0,0,0.6);\r\n    text-align: center;\r\n    border: 1px solid transparent;\r\n    border-right: solid 1px rgba(0,0,0,0.05);\r\n    border-bottom: solid 1px rgba(0,0,0,0.05);\r\n    line-height: 30px;\r\n    &.selected {\r\n      _box-shadow: inset 0px 0px 1px 1px #e9e9e9;\r\n      border: 1px solid black;\r\n    }\r\n  }\r\n}\r\n\r\n.messurements {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 14px;\r\n}\r\n.sensors {\r\n  display: flex; justify-content: space-around; margin: 10px;\r\n}\r\n.sensor-item {\r\n  background: white;\r\n  border-radius: 2px;\r\n  white-space: pre;\r\n  padding: 3px;\r\n  font-size: 13px;\r\n  position: absolute;\r\n}\r\n.sensor {\r\n  border: 1px solid transparent;\r\n}\r\n.sensor.active {\r\n  border-bottom: 2px solid;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
